exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit3-zero .finish{border-bottom:none;padding:0}.unit3-zero .intro .intro-side{float:left}.unit3-zero .intro .intro-side:first-child{width:38%}.unit3-zero .intro .intro-side:last-child{width:62%;padding-left:40px}.unit3-zero .intro p{clear:both}.unit3-zero .intro ul:not(:last-child){padding-left:17px}.unit3-zero .intro ul:not(:last-child) li{margin-bottom:8px}.unit3-zero .intro strong{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/modules/courses/3/3zero/supportingPoints/supportingPoints.scss
// module id = 661
// module chunks = 0